import { Component, OnInit } from '@angular/core';
import { FsItemComponent } from '../fs-item.component';

@Component({
  selector: 'prada-fs-card-item',
  templateUrl: './fs-card-item.component.html',
  styleUrls: ['./fs-card-item.component.scss'],
})
export class FsCardItemComponent extends FsItemComponent implements OnInit {}
